import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Dienststelle } from '../module/dienststelle';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DbService {
  constructor(private afs: AngularFirestore) {}

  getDienststelleData(dsCode: string): Observable<Dienststelle> {
    if (dsCode === '') {
      dsCode = 'Kein Dienststellencode';
    }

    return this.afs
      .collection(environment.collectionName)
      .doc<Dienststelle>(dsCode)
      .valueChanges();
  }

  searchDocumentsByName(name: string): Observable<Document[]> {
    return this.afs
      .collection<Document>(environment.collectionName, (ref) =>
        ref.where('leasingDuration', '==', '30;24'),
      )
      .snapshotChanges()
      .pipe(
        map((actions) =>
          actions.map((a) => {
            const data = a.payload.doc.data() as Document;
            const id = a.payload.doc.id;
            return { id, ...data };
          }),
        ),
      );
  }

  // a function to get all documents and return what is needed
  // cahnge map to customize what u need to return
  getDsCodesWithDocumentIdContaining() {
    /*  this.afs.collection<Document>(environment.collectionName)
      .snapshotChanges().pipe(
      map(actions => actions
        // tslint:disable-next-line:triple-equals
        .filter(a => a.payload.doc.data()['ustAG'] === 2 && a.payload.doc.data()['ustAb'] && a.payload.doc.data()['ustAb'] != ''  )
        .map(a => {
          return {
            id: a.payload.doc.id,
            ustAb:  a.payload.doc.data()['ustAb'],
            ustAg: a.payload.doc.data()['ustAG']
          };
        })
      )
    ).subscribe({
      next: (doc: any) => {
        console.log(doc);

      }
    });*/
  }

  add() {
    /*
    *   example how to add a new data to FirebaseDB
     this.afs.collection('/' + environment.collectionName )
      .doc('Viv-BBG-1024'.trim()).set(
      {
        name: 'BBG Berliner Bildungscampus für Gesundheitsberufe gGmbH',
        VBL: 0.0,
        disabledVBL: false,
        aganteil: 0,
        aganteilBeamte: 0,
        bundesland: 'bb',
        disabledBundesland: false,
        leasingfaktor: 0.033,
        uebernahmeprozent: 0.18,
        fairbetragBeamte: 0,
        fairbetrag: 0,
        disabledFairbetrag: false,
        inspektion: 2,
        sonderInspektion: 5.9,
        disabledInspektion: false,
        ustAG: 1,
        hasSaving: false,
        ustAGBeamte: 0,
        disabledUstAg: false,
        ustAb: '',
        disabledUstAb: false,
        ustAbBeamte: '',
        oneProzent: 1,
        oneProzentNetto: 0,
        oneProzentBeamte: 0,
        disabledOneProzent: false,
        verGeber: 'BARMENIA',
        versicherungNetto: 1,
        versicherungType: 'upgrade',
        maxPreis: 7000,
        minPreis: 699,
        leasingDuration: '36',
        leasingRateBezuschussen: false,
        disabledRadFahrSchutz: true,
        abwKonditionenBeamte: false,
        restwert: 0.1
      },
      { merge: true });
 */
  }
}
